export const EmptyState = ({ width, height }) => (
  <svg
    width={width ? width : "158"}
    height={height ? height : "160"}
    viewBox="0 0 158 160"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g id="Layer_1" clipPath="url(#clip0_21_507)">
      <g id="Group">
        <path
          id="Vector"
          d="M109.681 22.1138H107.785C106.709 22.1138 105.834 22.9886 105.834 24.065C105.834 25.1415 106.709 26.0163 107.785 26.0163H109.681C110.758 26.0163 111.632 25.1415 111.632 24.065C111.632 22.9886 110.758 22.1138 109.681 22.1138Z"
          fill="#1249BF"
        />
        <path
          id="Vector_2"
          d="M101.958 22.1138H60.4878C59.4114 22.1138 58.5366 22.9886 58.5366 24.065C58.5366 25.1415 59.4114 26.0163 60.4878 26.0163H101.958C103.034 26.0163 103.909 25.1415 103.909 24.065C103.909 22.9886 103.034 22.1138 101.958 22.1138Z"
          fill="#1249BF"
        />
      </g>
      <path
        id="Vector_3"
        d="M14.2439 6.92033L14.2211 17.2455H16.2049L17.3138 18.8325L36.039 5.70407L36.0488 17.239H39.9512L39.9414 4.22764L137.951 19.1837L138.54 15.3268L38.2829 0.0227642C38.1854 0.0097561 38.0878 0 37.9902 0H16.2081C15.6683 0 15.1512 0.22439 14.7805 0.621138L0.52356 15.922L3.37884 18.5821L14.2439 6.92033ZM31.8049 3.90244L18.1333 13.4927L18.1561 3.90244H31.8049Z"
        fill="#F3D9DA"
      />
      <path
        id="Vector_4"
        d="M50.6764 158.049C50.6666 151.873 46.065 146.67 39.9382 145.902L39.9577 30.6862H36.0553V43.7756L18.1691 35.5447V30.6341L14.2666 30.6537L14.2569 145.873C8.01298 146.517 3.26827 151.772 3.26501 158.049C3.26501 159.125 4.13981 160 5.21623 160H48.7252C49.8016 160 50.6764 159.125 50.6764 158.049ZM18.1658 60.9301L33.4666 67.9675L18.1626 75.0081V60.9301H18.1658ZM18.1626 102.013L33.5154 109.08L18.1626 116.146V102.013ZM20.2309 98.6667L36.0422 91.3886V105.945L20.2309 98.6667ZM36.0455 85.2163L20.6796 78.1463L36.0488 71.0764V85.2163H36.0455ZM33.4179 88.3024L18.1626 95.3236V81.2846L33.4179 88.3024ZM36.039 127.024L19.9414 119.62L36.039 112.208V127.024ZM33.4211 130.114L18.1593 137.138V123.096L33.4211 130.114ZM36.0488 64.8553L19.9902 57.4699L36.052 50.0813V64.8553H36.0488ZM18.1593 141.437L36.039 133.21V145.808H18.1593V141.437ZM33.5707 46.9268L18.1691 54.0163V39.8407L33.5707 46.9268ZM7.3951 156.098C8.30241 152.351 11.652 149.714 15.5057 149.711H38.4357C42.2862 149.717 45.6357 152.354 46.5431 156.098H7.3951Z"
        fill="#F3D9DA"
      />
      <path
        id="Vector_5"
        d="M125.255 72.5398C127.698 71.7138 129.659 69.8569 130.615 67.4602C131.018 66.4585 130.533 65.3236 129.535 64.9203C128.533 64.5171 127.398 65.0016 126.995 66C126.25 67.8732 124.439 69.1057 122.423 69.1024C119.672 69.1024 117.444 66.8715 117.447 64.1203C117.447 61.3724 119.675 59.1447 122.423 59.1447C123.499 59.1447 124.374 58.2699 124.374 57.1935V42.2764H132.254C133.33 42.2764 134.205 41.4016 134.205 40.3252V32.6049H138.302C139.379 32.6049 140.254 31.7301 140.254 30.6537C140.254 30.6537 140.254 30.6472 140.254 30.6439L140.198 17.2423C140.195 16.1691 139.32 15.2976 138.247 15.3008H1.95122C0.874797 15.3008 0 16.1756 0 17.252V30.6537C0 31.7301 0.874797 32.6049 1.95122 32.6049H110.244V40.3252C110.244 41.4016 111.119 42.2764 112.195 42.2764H120.468V55.4602C115.681 56.5659 112.699 61.3398 113.805 66.1268C114.442 68.8813 116.351 71.1707 118.946 72.2894C118.946 72.2894 121.652 73.5382 125.252 72.5366L125.255 72.5398ZM114.146 32.6049H118.049C119.125 32.6049 120 31.7301 120 30.6537C120 29.5772 119.125 28.7024 118.049 28.7024H3.90244V19.2033H136.302L136.341 28.7024H125.207C124.13 28.7024 123.255 29.5772 123.255 30.6537C123.255 31.7301 124.13 32.6049 125.207 32.6049H130.302V38.374H114.15V32.6049H114.146Z"
        fill="#1249BF"
      />
      <path
        id="Vector_6"
        d="M121.489 134.442C122.566 134.442 123.441 133.567 123.441 132.491V121.109C123.441 120.033 122.566 119.158 121.489 119.158C120.413 119.158 119.538 120.033 119.538 121.109V132.491C119.538 133.567 120.413 134.442 121.489 134.442Z"
        fill="#1249BF"
      />
      <path
        id="Vector_7"
        d="M99.9805 153.45C99.9805 152.374 99.1057 151.499 98.0293 151.499H86.6471C85.5707 151.499 84.6959 152.374 84.6959 153.45C84.6959 154.527 85.5707 155.402 86.6471 155.402H98.0293C99.1057 155.402 99.9805 154.527 99.9805 153.45Z"
        fill="#1249BF"
      />
      <path
        id="Vector_8"
        d="M143.73 155.402H155.112C156.189 155.402 157.063 154.527 157.063 153.45C157.063 152.374 156.189 151.499 155.112 151.499H143.73C142.654 151.499 141.779 152.374 141.779 153.45C141.779 154.527 142.654 155.402 143.73 155.402Z"
        fill="#1249BF"
      />
      <path
        id="Vector_9"
        d="M106.237 139.281C106.855 138.4 106.644 137.184 105.763 136.563L96.4455 130.023C95.5642 129.405 94.3479 129.616 93.7268 130.498C93.1089 131.379 93.3203 132.595 94.2016 133.216L103.519 139.756C104.4 140.374 105.616 140.163 106.237 139.281Z"
        fill="#1249BF"
      />
      <path
        id="Vector_10"
        d="M140.091 139.759L149.408 133.22C150.289 132.602 150.504 131.382 149.883 130.501C149.265 129.62 148.046 129.405 147.164 130.026L137.847 136.566C136.966 137.184 136.751 138.403 137.372 139.285C137.99 140.166 139.21 140.38 140.091 139.759Z"
        fill="#1249BF"
      />
    </g>
    <defs>
      <clipPath id="clip0_21_507">
        <rect width="157.063" height="160" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
